/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Debt_No_PaymentsInputs */

const vi_report_debt_no_payments = /** @type {(inputs: Report_Debt_No_PaymentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có thanh toán`)
};

/**

* @param {Report_Debt_No_PaymentsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_debt_no_payments = /** @type {((inputs?: Report_Debt_No_PaymentsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Debt_No_PaymentsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_debt_no_payments(inputs)
});